export type ILogoProps = {
    color?: `#${string}`
    width?: number
    height?: number
    className?: string
}

export const Logo = ({ color = '#000000', width = 16, height = 19, className }: ILogoProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 16 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M0.151805 12.3003L7.57849 0.660622C7.77506 0.352546 8.22494 0.352545 8.42151 0.660621L15.8482 12.3003C15.9424 12.448 15.9525 12.6342 15.8748 12.7911L13.3085 17.9733C13.0686 18.4578 12.4105 18.537 12.0625 18.1233L4.74623 9.42748C4.52886 9.16913 4.12319 9.19604 3.94186 9.48085L3.18114 10.6757C3.06412 10.8595 3.0796 11.0979 3.21941 11.265L6.19179 14.8182C6.34772 15.0046 6.34704 15.2761 6.19018 15.4617L3.9377 18.1271C3.58923 18.5394 2.93235 18.4596 2.69276 17.9758L0.125246 12.7911C0.0475128 12.6342 0.0575879 12.448 0.151805 12.3003Z"
                fill={color}
            />
        </svg>
    )
}
